import { useState } from 'react'
import { ButtonPrimary } from 'components/Button/Button'
import CardWrapper from 'components/wrappers/CardWrapper'
import Dropdown from 'share-ui/components/Dropdown/Dropdown'
import TextField from 'share-ui/components/TextField/TextField'
import styled from 'styled-components'
import TypographyPrimary from 'components/Typography/Primary'
import IconButton from 'share-ui/components/IconButton/IconButton'
import { StyledEditIcon } from 'pages/Subnets/panels/ApiPanel/columnConfig'
import { StyledNavigationChevronUp } from 'styles/styledIcons.css'

const SettingsSearchForm = ({
    toolOptions,
    title,
    open = false,
    handleSendMessage,
}: {
    toolOptions: { value: string; label: string }[]
    title: string
    open?: boolean
    handleSendMessage: (
        text: string,
        tools: string[],
        date: string,
        model: string,
        responseType: string,
    ) => void
}) => {
    const [isOpen, setIsOpen] = useState(open)
    const [inputValue, setInputValue] = useState('')
    const [tools, setTools] = useState<{ value: string; label: string }[]>([])

    const handleOpen = () => {
        setIsOpen(!isOpen)
    }

    const handleSave = () => {
        const mappedTools = tools.map(tool => tool.value)

        handleSendMessage(inputValue, mappedTools, '', '', '')
    }

    return (
        <CardWrapper>
            <StyledTitle>
                <TypographyPrimary value={title} size='medium' bold />

                <IconButton
                    onClick={handleOpen}
                    icon={() => <>{isOpen ? <StyledNavigationChevronUp /> : <StyledEditIcon />}</>}
                    size={IconButton.sizes?.SMALL}
                    kind={IconButton.kinds?.TERTIARY}
                    ariaLabel={!isOpen ? 'Edit' : 'Close'}
                />
            </StyledTitle>
            {isOpen && (
                <StyledInnerWrapper>
                    <TextField title='Search parameters' onChange={setInputValue} />
                    <Dropdown
                        label='Tools'
                        value={tools}
                        onChange={(value: []) => {
                            if (value === null) {
                                setTools([])
                            } else {
                                setTools(value)
                            }
                        }}
                        onOptionRemove={(value: { value: string; label: string }) => {
                            setTools(params =>
                                params.filter(oldValue => oldValue.value !== value.value),
                            )
                        }}
                        options={toolOptions}
                        multi
                    />
                    <StyledButtonWrapper>
                        <ButtonPrimary onClick={handleSave}>Save</ButtonPrimary>
                    </StyledButtonWrapper>
                </StyledInnerWrapper>
            )}
        </CardWrapper>
    )
}

export default SettingsSearchForm

const StyledInnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    margin-top: 30px;
`

const StyledButtonWrapper = styled.div`
    margin-top: 20px;
    margin-left: auto;
`

const StyledTitle = styled.div`
    display: flex;
    align-items: center;

    justify-content: space-between;
`
